export const EMPLOYEES = 'Employees';
export const CUSTOMERS = 'Customers';
export const GUESTS = 'Guests';

export const GROUPS_TAKING_THE_RIDE = [EMPLOYEES, CUSTOMERS, GUESTS];
